<template>
    <v-main 
    v-if="activeMenu === 'recent'"
    style="overflow-y: auto; 
    overflow-x: hidden;">

        <v-container fluid class="pa-4">

            <!-- Toolbar -->
            <div class="d-flex justify-space-between align-center mb-3">
                <div class="text-medium-emphasis">
                    <strong>Showing Recent {{ visibleItems.length }} items</strong>
                </div>
            </div>

            <!-- Grid View -->
            <div v-if="viewMode === 'grid'">

                <!-- Files Section -->
                <div v-if="visibleFiles.length > 0">

                    <v-row>
                        <v-col
                        v-for="file in visibleFiles"
                        :key="file.id"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        >
                            <div class="file-item-container" @contextmenu.prevent="showFileContextMenu($event, file)">
                                <v-card
                                class="file-card h-100"                                    
                                @click="openFile(file)"
                                >
                                    <div class="file-thumbnail">
                                        <v-img
                                        v-if="isImageFile(file)"
                                        :src="getFilePreviewUrl(file)"
                                        cover
                                        class="file-preview-image"
                                        />
                                        <div v-else class="file-icon-container">
                                            <v-icon
                                            size="80"
                                            :color="getFileIconColor(file)"
                                            >
                                                {{ getFileIcon(file) }}
                                            </v-icon>
                                        </div>
                                    </div>
                                    <v-card-text class="pa-3">
                                        <div class="file-name text-truncate font-weight-medium">{{ file.original_name }}</div>
                                        <div class="text-caption text-medium-emphasis">{{ formatSize(file.size || 0) }}</div>
                                    </v-card-text>
                                </v-card>
                                
                                <div class="file-menu-btn">
                                    <v-btn
                                    icon="mdi-dots-vertical"
                                    size="x-small"
                                    variant="text"
                                    @click.stop="showFileContextMenu($event, file)"
                                    />
                                </div>
                            </div>
                        </v-col>
                    </v-row>

                </div>

                <!-- Empty State -->
                <v-card v-if="visibleFiles.length === 0" flat class="text-center py-12">
                    <v-icon size="80" color="grey-lighten-1" class="mb-3">mdi-timeline-remove</v-icon>
                    <div class="text-h6 text-medium-emphasis">No Files are Uploaded Recently</div>
                </v-card>
            </div>

            <!-- List View -->
            <v-card v-else>
                <v-table>
                    <thead>
                        <tr>
                            <th style="width: 40px"></th>
                            <th>Name</th>
                            <th class="text-right" style="width: 120px">Size</th>
                            <th style="width: 100px"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                        v-for="item in visibleItems"
                        :key="item.id"
                        class="cursor-pointer"
                        @click="handleItemClick(item)"
                        @contextmenu.prevent="showListContextMenu($event, item)"
                        >
                            <td>
                                <v-checkbox
                                    :model-value="selectedItems.has(item.id)"
                                    hide-details
                                    density="compact"
                                    @click.stop
                                    @update:model-value="toggleSelect(item.id, $event)"
                                />
                            </td>

                            <td>
                                <div class="d-flex align-center ga-3">
                                    <v-icon
                                    :color="item.original_name ? getFileIconColor(item) : 'amber'"
                                    >
                                        {{ item.original_name ? getFileIcon(item) : "mdi-folder" }}
                                    </v-icon>

                                    <div>
                                        <div class="font-weight-medium">{{ item.original_name || item.name }}</div>

                                        <div class="text-caption text-medium-emphasis">
                                            {{ formattedDate(item.created_at || item.modified) }}
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td class="text-right">
                                {{ item.size ? formatSize(item.size) : "" }}
                            </td>

                            <td>
                                <v-btn
                                    icon="mdi-dots-vertical"
                                    size="small"
                                    variant="text"
                                    @click.stop="showListContextMenu($event, item)"
                                />
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card>
        </v-container>
    </v-main>
</template>

<script>
export default {
    name: "documentsRecent",
    props: {
        viewMode: String,
        activeMenu: String,
        selectedItems: Array,
        visibleItems: Array,
        visibleFiles: Array,
        showFolderContextMenu: Function,
        openFolder: Function,
        openFile: Function,
        isImageFile: Function,
        getFilePreviewUrl: Function,
        getFileIconColor: Function,
        getFileIcon: Function,
        showFileContextMenu: Function,
        handleItemClick: Function,
        showListContextMenu: Function,
        toggleSelect: Function,
        formattedDate: Function,
        formatSize: Function,
    },
}
</script>
<style scoped>
    
.border-dashed {
    border-style: dashed !important;
}

.cursor-pointer {
    cursor: pointer;
}

.folder-card {
    display: flex;
    height: 45px;
    align-items: center;
    padding: 4px 10px;
}

.file-item-container {
    position: relative;
}

.file-card {
    border-radius: 8px;
    transition: all 0.2s ease;
    overflow: hidden;
}

.file-thumbnail {
    width: 100%;
    height: 150px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
}

.file-preview-image {
    width: 100%;
    height: 100%;
}

.file-icon-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.file-name {
    font-size: 0.875rem;
    line-height: 1.2;
    max-height: 2.4em;
}

.file-menu-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.file-menu-btn .v-btn {
    background: rgba(255, 255, 255, 0.9) !important;
}

.section-title {
    font-size: 0.875rem;
    font-weight: 500;
    color: #5f6368;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.search-field {
    transition: max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.search-field :deep(.v-field) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>